import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';

export const SmallCloseIcon = styled(CloseIcon)(({ theme }) => ({
  fontSize: '1rem',
  verticalAlign: 'middle',
  marginLeft: theme.spacing(1),
}));
